"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBNewTable = require("./HBNewTable.styles");
var _HBNewTableRowList = _interopRequireDefault(require("./HBNewTableRowList"));
var _HBNewTableSelectableHeader = _interopRequireDefault(require("./HBNewTableSelectableHeader"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBNewTableNoResults = _interopRequireDefault(require("./HBNewTableNoResults"));
var _HBNewTableExpandedIndicator = _interopRequireDefault(require("./HBNewTableExpandedIndicator"));
var _useDetectScroll2 = require("../common/useDetectScroll");
var _HBNewTableRowCheckbox = _interopRequireDefault(require("./HBNewTableRowCheckbox"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CHECKBOX_COLUMN_ID = 'row-checkbox';
var HBNewTable = function HBNewTable(_ref) {
  var _selectableProps$sele, _selectableProps$sele2;
  var items = _ref.items,
    columnDefinitions = _ref.columnDefinitions,
    getItemId = _ref.getItemId,
    selectableProps = _ref.selectableProps,
    infiniteScrollProps = _ref.infiniteScrollProps,
    expandableProps = _ref.expandableProps,
    pinProps = _ref.pinProps,
    hasSpacer = _ref.hasSpacer,
    testId = _ref.testId,
    _ref$testIdName = _ref.testIdName,
    testIdName = _ref$testIdName === void 0 ? 'placeholder' : _ref$testIdName,
    tourId = _ref.tourId,
    ariaLabel = _ref.ariaLabel,
    maxHeight = _ref.maxHeight,
    noResultsProps = _ref.noResultsProps,
    useNativeTable = _ref.useNativeTable;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'table',
    componentName: 'HBNewTable'
  });
  var isSelectable = !!selectableProps;
  var isSelectableMode = (selectableProps === null || selectableProps === void 0 || (_selectableProps$sele = selectableProps.selectedItemIds) === null || _selectableProps$sele === void 0 ? void 0 : _selectableProps$sele.length) > 0;
  var hideTableHeader = !(selectableProps !== null && selectableProps !== void 0 && selectableProps.showTableHeaderOnSelect) && (selectableProps === null || selectableProps === void 0 || (_selectableProps$sele2 = selectableProps.selectedItemIds) === null || _selectableProps$sele2 === void 0 ? void 0 : _selectableProps$sele2.length) > 0;
  var TableComponent = useNativeTable ? _HBNewTable.NewTableStyledTableTable : _HBNewTable.NewTableStyledTableDiv;
  var noResultsJsx = function noResultsJsx() {
    return noResultsProps && /*#__PURE__*/_react["default"].createElement(_HBNewTableNoResults["default"], {
      title: noResultsProps.title,
      subtitle: noResultsProps.subtitle,
      columnsCount: columnDefinitions.length
    });
  };
  var enrichedColumnDefinitions = [].concat((0, _toConsumableArray2["default"])(selectableProps ? [{
    id: CHECKBOX_COLUMN_ID,
    renderHeader: function renderHeader() {
      return /*#__PURE__*/_react["default"].createElement(_HBNewTableRowCheckbox["default"], {
        item: undefined,
        itemId: "select-all",
        isItemSelected: selectableProps === null || selectableProps === void 0 ? void 0 : selectableProps.allItemsSelected,
        onSelectItem: function onSelectItem(_, isSelected) {
          if (isSelected) {
            selectableProps.selectAll();
          } else {
            selectableProps.clearSelections();
          }
        },
        testIdName: "select-all"
      });
    },
    renderCell: function renderCell(item) {
      var itemId = getItemId(item);
      return /*#__PURE__*/_react["default"].createElement(_HBNewTableRowCheckbox["default"], {
        item: item,
        isItemSelected: selectableProps.selectedItemIds.includes(itemId),
        itemId: itemId,
        onSelectItem: selectableProps.onSelectItem
      });
    },
    width: "".concat(_HBNewTable.TABLE_CHECKBOX_COLUMN_WIDTH, "px")
  }] : []), (0, _toConsumableArray2["default"])(columnDefinitions), (0, _toConsumableArray2["default"])(expandableProps !== null && expandableProps !== void 0 && expandableProps.shouldShowExpandColumn ? [{
    id: 'expandableIndicator',
    renderCell: function renderCell(_, _ref2) {
      var isRowExpanded = _ref2.isRowExpanded;
      return /*#__PURE__*/_react["default"].createElement(_HBNewTableExpandedIndicator["default"], {
        isRowExpanded: isRowExpanded
      });
    },
    width: '46px'
  }] : []));
  var ref = (0, _react.useRef)(null);
  var _useDetectScroll = (0, _useDetectScroll2.useDetectScroll)({
      elementRef: ref,
      direction: 'horizontal'
    }),
    isScrolled = _useDetectScroll.isScrolled,
    isScrolledToEnd = _useDetectScroll.isScrolledToEnd;
  return /*#__PURE__*/_react["default"].createElement(Container, null, isSelectableMode && /*#__PURE__*/_react["default"].createElement(_HBNewTableSelectableHeader["default"], {
    selectableProps: selectableProps
  }), /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableWrapper, (0, _extends2["default"])({}, pinProps, {
    ref: ref,
    $isSelectable: isSelectable,
    $isScrolled: isScrolled,
    $isScrolledToEnd: isScrolledToEnd,
    $maxHeight: maxHeight
  }), /*#__PURE__*/_react["default"].createElement(TableComponent, {
    "data-testid": finalTestId,
    "data-tour-id": tourId,
    role: "table",
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableColGroup, null, enrichedColumnDefinitions.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableCol, {
      key: column.id,
      $width: column.width
    });
  })), /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledThead, null, /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledTrHeader, {
    hasSpacer: hasSpacer,
    $isSelectable: isSelectable
  }, enrichedColumnDefinitions.map(function (column) {
    var shouldHide = column.id !== CHECKBOX_COLUMN_ID && hideTableHeader;
    var component = column.renderHeader ? column.renderHeader({
      column: column
    }) : null;
    return /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledTh, {
      key: column.id,
      hide: shouldHide
    }, component);
  }))), items.length > 0 ? /*#__PURE__*/_react["default"].createElement(_HBNewTableRowList["default"], {
    items: items,
    columnDefinitions: enrichedColumnDefinitions,
    getItemId: getItemId,
    selectableProps: selectableProps,
    infiniteScrollProps: infiniteScrollProps,
    expandableProps: expandableProps,
    hasSpacer: hasSpacer
  }) : noResultsJsx())));
};
var _default = exports["default"] = HBNewTable; // -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTable__Container",
  componentId: "sc-18lic1q-0"
})(["position:relative;"]);
//# sourceMappingURL=HBNewTable.js.map